exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".p-button {\n  height: 28px; }\n  .p-button:focus {\n    border-color: #2fc78790;\n    -webkit-box-shadow: 0 0 0 0.2rem #2fc78740;\n            box-shadow: 0 0 0 0.2rem #2fc78740; }\n  .p-button:focus:hover {\n    border-color: #2fc78790 !important; }\n  .p-button.p-highlight {\n    background: #2baf78 !important; }\n", ""]);

